import { getAuthAxiosBackend } from "@/helpers/axios"

class RolesServices {
    getAll(data = {}) {
        return getAuthAxiosBackend().get('Security/User/roles-with-permissions', { params: data })
    }
}

export default new RolesServices()
